import React, { useState } from "react";
import "./index.scss";
import { TGetChatHistoryListResponse } from "../../../utils/types/agrocraftArtisan";
import HistoryIcon from "@mui/icons-material/History";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import {
  CUSTOM_EVENTS,
  appLogEvent,
} from "../../../utils/analytics";
import deleteIcon from "../../../assets/images/deleteIcon.svg";
import Dialog from "../../../components/confirmationPopup/confirmationPopup";
import { useDeleteHistoryMutation } from "../../../services/agrocraftArtisan";
import { showAlert } from '../../../reduxActions/alert';
import { useDispatch } from "react-redux";

export const ChatHistory = ({
  setSessionId,
  chatHistoryList,
  userId,
  activeSessionId,
  onAfterDelete,
}: {
  setSessionId: React.Dispatch<
    React.SetStateAction<number | undefined>
  >;
  chatHistoryList:
  | TGetChatHistoryListResponse[]
  | undefined;
  userId: string | null;
  activeSessionId?: number;
  onAfterDelete?: () => void
}) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedHistoryId, setSelectedHistoryId] = useState<number | null>(null);
  const [deleteHistory] = useDeleteHistoryMutation();
  const dispatch = useDispatch();

  const handleOpenPopup = (id: number) => {
    setSelectedHistoryId(id);
    setShowConfirm(true);
  };

  const handleClosePopup = () => {
    setShowConfirm(false);
    setSelectedHistoryId(null);
  };

  const handleConfirmDelete = async () => {
    if (selectedHistoryId === null) return;

    const deletingId = selectedHistoryId;

    if (activeSessionId === deletingId) {
      setSessionId(undefined);
    }
    try {
      await deleteHistory({ sessionId: deletingId }).unwrap();
      setTimeout(() => {
        onAfterDelete?.();
      dispatch(
        showAlert({
          content: 'History item deleted successfully',
          severity: 'success',
        })
      );
      }, 1000);
    } catch (err) {
      console.error('Delete failed', err);
    } finally {
      setShowConfirm(false);
      setSelectedHistoryId(null);
    }
  };

  return (
    <>
      <div className="agrocraft-artisian-sidebar overflow-auto">
        <div className="px-4">
          {!userId && (
            <div
              className="sidebar-newprompt cursor-pointer"
              onClick={() => {
                appLogEvent(CUSTOM_EVENTS.NEW_PROMPT_CLICK);
                setSessionId(undefined);
              }}>
              <BorderColorIcon
                style={{ marginRight: '16px' }}
              />
              <span>New Prompt</span>
            </div>
          )}
          <div
            className="sidebar-history"
            style={{ marginTop: userId ? '22px' : '0px' }}>
            <HistoryIcon style={{ marginRight: '6px' }} />
            <span>History</span>
          </div>
        </div>
        <div className="sidebar-historyitems px-4">
          {chatHistoryList && chatHistoryList?.length > 0 ? (
            chatHistoryList.map((historyItem) => (
              <div
                key={historyItem.Id}
                className={`historyitem ${activeSessionId === historyItem.Id ? "active" : ""
                  }`}
                onClick={() => {
                  appLogEvent(
                    CUSTOM_EVENTS.HISTORY_ITEM_CLICKED,
                    { historyItemId: historyItem.Id }
                  );
                  setSessionId(historyItem.Id);
                }}
              >
                <span className="historyitem-text" title={historyItem.Name}>
                  {historyItem.Name}
                </span>

                <button
                  type="button"
                  className="historyitem-delete-btn"
                  title="Delete"
                  aria-label={`Delete "${historyItem.Name}"`}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenPopup(historyItem.Id);
                  }}
                >
                  <img src={deleteIcon} alt="" />
                </button>
              </div>
            ))
          ) : (
            "No History found"
          )}
        </div>
      </div>

      {/* Confirmation Dialog */}
      <Dialog
        show={showConfirm}
        title="Delete Chat?"
        message="Are you sure you want to delete this item?"
        primaryButtonText={"Delete"}
        secondaryButtonText="Cancel"
        primaryButtonAction={handleConfirmDelete}
        secondaryButtonAction={handleClosePopup}
        buttonStyle="Square"
      />
    </>
  );
};